import { useCallback } from "react";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Module } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellLink from "ds/components/Table/Row/CellLink";
import { replaceSubdomain } from "utils/history";
import { getSubdomain } from "shared/Analytics";

import useModulesAnalytics from "../../useModulesAnalytics";
import { canAccessModule } from "../../helpers";
import { SHARED_MODULE_ACCESS_INFO } from "../../constants";

const ModulesTableNameLinkCell = ({ item: module, ...cellProps }: TableSimpleCellProps<Module>) => {
  const trackAnalytics = useModulesAnalytics();
  const currentAccountSubdomain = getSubdomain();
  let moduleOrigin: string;

  if (currentAccountSubdomain !== module.ownerSubdomain) {
    moduleOrigin = replaceSubdomain(window.location.origin, module.ownerSubdomain);
  } else {
    moduleOrigin = "";
  }

  const moduleUrl = `${moduleOrigin}/module/${module.id}`;

  const handlePress = useCallback(() => {
    trackAnalytics("Name link clicked");
  }, [trackAnalytics]);

  const isDisabled = !moduleOrigin && !canAccessModule(module);

  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellLink
        href={moduleUrl}
        onPress={handlePress}
        disabled={isDisabled}
        tooltip={isDisabled && SHARED_MODULE_ACCESS_INFO}
        target={moduleOrigin ? "_blank" : undefined}
      >
        {module.name}
      </TableCellLink>
    </TableSimpleCell>
  );
};

export default ModulesTableNameLinkCell;
